module.exports = __webpack_public_path__ + "static/media/messaging-instance.80e8acaf.png";